/**
 * Singleton store for event start times (UTC ISO strings).
 *
 * Populated by sportsStream during init. Consumed by useFillProbability
 * to compute hours_to_tipoff without modifying GameData types.
 */

const store = new Map<string, string>();

export function setEventStartTimeUtc(eventTicker: string, isoUtc: string): void {
  store.set(eventTicker, isoUtc);
}

export function getEventStartTimeUtc(eventTicker: string): string | null {
  return store.get(eventTicker) ?? null;
}

/**
 * Compute hours remaining until tipoff.
 * Returns null if ticker not found, time is invalid, or game already started.
 */
export function getHoursToTipoff(eventTicker: string, nowMs?: number): number | null {
  const iso = store.get(eventTicker);
  if (!iso) return null;

  const tipoffMs = new Date(iso).getTime();
  if (isNaN(tipoffMs)) return null;

  const now = nowMs ?? Date.now();
  const hours = (tipoffMs - now) / 3_600_000;

  return hours < 0 ? null : hours;
}

export function clearEventStartTimes(): void {
  store.clear();
}
